import script from "./DataTableColumnsSelection.vue?vue&type=script&setup=true&lang=ts"
export * from "./DataTableColumnsSelection.vue?vue&type=script&setup=true&lang=ts"

import "./DataTableColumnsSelection.vue?vue&type=style&index=0&id=603c8bca&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-603c8bca"]])

export default __exports__